import { CustomerOrderData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const customerOrdersApi =
	apiResource<CustomerOrderData>('customer-orders');
